import React, { createContext, useContext, useState } from "react";

/**
 * The entity table's utility gutter (drag handle, checkbox, expand toggle)
 * varies in width with which cells a row qualifies for, so content outside the
 * table cannot hardcode a matching indent.
 *
 * A row measures its gutter and reports the width here; the provider exposes it
 * as a CSS custom property on its own element, so any descendant can line up
 * with `var(--utility-gutter-width)`. Consumers should supply a fallback for
 * first paint and for tables with no rows to measure.
 */
const GUTTER_WIDTH_VAR = "--utility-gutter-width";

const UtilityGutterWidthContext = createContext<(width: number) => void>(
  () => undefined,
);

export const useSetUtilityGutterWidth = () =>
  useContext(UtilityGutterWidthContext);

export const UtilityGutterWidthProvider = ({
  children,
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  const [width, setWidth] = useState<number | null>(null);

  return (
    <UtilityGutterWidthContext.Provider value={setWidth}>
      <div
        {...rest}
        className={className}
        style={
          width === null
            ? undefined
            : ({ [GUTTER_WIDTH_VAR]: `${width}px` } as React.CSSProperties)
        }
      >
        {children}
      </div>
    </UtilityGutterWidthContext.Provider>
  );
};
